import { formatFloors } from '../formatters/floors';
import { formatArea } from '../formatters/area';

interface IParams {
  area?: number;
  floors?: number;
}
export const stringifyFeatures = ({ area, floors }: IParams) => {
  return [area && formatArea(area), floors && formatFloors(floors)].filter(Boolean).join(' ･ ');
};
